module.exports = __webpack_public_path__ + "static/media/app.7e868534.png";